/* eslint-disable no-empty-pattern */
import apiClientV1 from "@/config/apiv1";
import apiClient from "@/config/api";

const actions = {
  getMySubscription({ commit }) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .get("/me/subscription")
        .then((res) => {
          commit("SET_MY_SUBSCRIPTION", res.data.data);
          commit("SET_QUEUED_SUBSCRIPTIONS", res.data.queued_subscriptions || []);
          resolve(res.data.data);
        })
        .catch((err) => reject(err));
    });
  },

  getMyProperties({ commit }, page = 1) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .get(`/me/properties?per_page=15&page=${page}`)
        .then((res) => {
          commit("SET_MY_PROPERTIES", {
            data: res.data.data,
            meta: res.data.meta,
          });
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },

  async getMyPropertyBySlug({}, slug) {
    let property = null;
    try {
      const response = await apiClientV1.get("/me/properties", {
        params: { slug, per_page: 1, all: true },
      });
      const payload = response.data.data;
      const properties = Array.isArray(payload) ? payload : payload?.data || [];
      property = properties.find((item) => item.slug === slug) || null;
    } catch (error) {
      if (![403, 404].includes(error.response?.status)) throw error;
    }

    if (!property) {
      const response = await apiClient.get(`/properties/slug/${encodeURIComponent(slug)}`);
      property = response.data.data;
    }
    if (!property || property.slug !== slug) return null;

    const id = Number(property.id);
    if (!Number.isSafeInteger(id) || id < 1) {
      throw new Error("A API devolveu um ID de imóvel inválido.");
    }
    return { ...property, id };
  },

  activateProperty({ commit }, id) {
    const propertyId = Number(id);
    if (!Number.isSafeInteger(propertyId) || propertyId < 1) {
      return Promise.reject(new Error("ID de imóvel inválido."));
    }

    return new Promise((resolve, reject) => {
      apiClientV1
        .post(`/me/properties/${propertyId}/activate`)
        .then((res) => {
          if (res.data.property) commit("UPDATE_MY_PROPERTY", res.data.property);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },

  deactivateProperty({ commit }, id) {
    const propertyId = Number(id);
    if (!Number.isSafeInteger(propertyId) || propertyId < 1) {
      return Promise.reject(new Error("ID de imóvel inválido."));
    }

    return new Promise((resolve, reject) => {
      apiClientV1
        .post(`/me/properties/${propertyId}/deactivate`)
        .then((res) => {
          if (res.data.property) commit("UPDATE_MY_PROPERTY", res.data.property);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },

  getAdminSubscriptions({ commit }, params = {}) {
    const query = new URLSearchParams();
    if (params.status) query.set("status", params.status);
    if (params.expiring_in) query.set("expiring_in", params.expiring_in);
    query.set("per_page", params.per_page || 20);
    if (params.page) query.set("page", params.page);

    return new Promise((resolve, reject) => {
      apiClientV1
        .get(`/admin/subscriptions?${query.toString()}`)
        .then((res) => {
          commit("SET_ADMIN_SUBSCRIPTIONS", {
            data: res.data.data,
            meta: res.data.meta,
          });
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },

  createSubscription({}, payload) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .post("/admin/subscriptions", payload)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },

  initiatePayment({}, payload) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .post("/me/subscriptions/pay", payload, { timeout: 100000 })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },

  addExtraSlots({}, payload) {
    return apiClientV1
      .post("/me/subscriptions/slots", payload, { timeout: 100000 })
      .then((res) => res.data);
  },

  getPaymentStatus({}, reference) {
    return apiClientV1
      .get(`/me/subscriptions/pay/${encodeURIComponent(reference)}`)
      .then((res) => res.data);
  },

  initiateAdminPayment({}, payload) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .post("/admin/subscriptions/pay", payload, {
          timeout: 100000,
          headers: { "Idempotency-Key": payload.idempotency_key },
        })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },

  getAdminPaymentStatus({}, reference) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .get(`/admin/subscriptions/pay/${encodeURIComponent(reference)}`)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },

  updateSubscription({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .put(`/admin/subscriptions/${id}`, payload)
        .then((res) => {
          if (res.data.data) commit("UPDATE_SUBSCRIPTION", res.data.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },
};

export default actions;
